import { render, staticRenderFns } from "./WorkOrderStatusTag.vue?vue&type=template&id=0014aa6d&scoped=true&"
import script from "./WorkOrderStatusTag.vue?vue&type=script&lang=ts&"
export * from "./WorkOrderStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0014aa6d",
  null
  
)

export default component.exports